import { SortArrowDown, SortArrowUp } from '@icons'
import cn from '@integrations/classnames'

interface Props {
  headCellName: string
  sort: string
  isSortAsc: boolean
}

function SortArrow({ headCellName, sort, isSortAsc }: Props) {
  return sort === headCellName ? (
    <span className={cn('sort-icons')}>
      {isSortAsc ? <SortArrowUp fill={'var(--banky-white)'} /> : <SortArrowDown fill={'var(--banky-white)'} />}
    </span>
  ) : null
}

export default SortArrow
